import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'tenderingText'
})
export class TenderingTextPipe implements PipeTransform {
  /**
   *
   */
  constructor(private translate: TranslateService) {

  }
  transform(value: string): any {
    if (value == null) {
      return 'TRACK_RACES.YEARS_OLD_HORSES'; // Varsayılan değer
    }
    const isUpward = value.includes('upward');
    const translateKey = isUpward ? 'TRACK_RACES.YEARS_OLD_AND_UPWARD_HORSES' : 'TRACK_RACES.YEARS_OLD_HORSES';
    return translateKey;
  }
}
